<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="落地页详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">H5链接:</el-col>
        <el-col :span="19"><span ref='path'>{{ showForm.typehood === 2 ? `https://tgh5.xiongyuanedu.com/#/pages/landing/landing?id=${showForm.pageId}` : `https://tg.xiongyuanedu.com/?pageId=${showForm.pageId}` }}</span> <el-button type="primary" class="ml-10" @click="copy('path')" size="mini" plain>复制</el-button><el-button type="warning" class="ml-10" @click="handleGenerate" plain>生成短链接</el-button> </el-col>
      </el-row>
      <el-row v-if="showForm.typehood === 1">
        <el-col :span="5">小程序链接:</el-col>
        <el-col :span="19"><span ref='miniprogramPath'>{{ `pages/landing/landing?id=${showForm.pageId}` }}</span> <el-button type="primary" class="ml-10" @click="copy('miniprogramPath')" size="mini" plain>复制</el-button></el-col>
      </el-row>
      <el-row v-if="!!shortLink">
        <el-col :span="5">短链接:</el-col>
        <el-col :span="19"><span ref='shortPath'>{{ shortLink }}</span> <el-button type="primary" class="ml-10" @click="copy('shortPath')" size="mini" plain>复制</el-button> </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">类型:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.typehood === 2">H5</el-tag>
          <el-tag v-else type="success">小程序</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">商品轮播图:</el-col>
        <el-col :span="12">
          <el-carousel :interval="4000" height="300px" class="e-carousel">
            <el-carousel-item v-for="item in showForm.imageList || []" :key="item.name">
              <el-image :src="item.url" fit="scale-down"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row v-if="showForm.typehood === 2">
        <el-col :span="5">跳转链接:</el-col>
        <el-col :span="19">
          {{ showForm.actionLink }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">备注:</el-col>
        <el-col :span="19">{{ showForm.text }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">排序:</el-col>
        <el-col :span="19">{{ showForm.order }}</el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getShortLink } from '@/api/app'
export default {
  name: 'LandingDetail',
  data() {
    return {
      showForm: {},
      dialogFormVisible: false,
      shortLink: '',
    }
  },
  methods: {
    show(row) {
      if (row) {
        this.showForm = {
          pageId: row.pageId,
          title: row.title,
          typehood: row.typehood || 1,
          ...row.basic
        }
        this.shortLink = ''
        this.dialogFormVisible = true
      }
    },
    async handleGenerate() {
      const { typehood, pageId } = this.showForm
      const url = typehood === 2 ? `https://tgh5.xiongyuanedu.com/#/pages/landing/landing?id=${pageId}` : `https://tg.xiongyuanedu.com/?pageId=${pageId}`
      const result = await getShortLink({ url })
      if(!!result) {
        this.shortLink = result
      }
    },
    copy(ref) {
      const text = this.$refs[ref].innerText
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
